import { render, staticRenderFns } from "./btn-with-tip.mpx?vue&type=template&id=b54844e0&isComponent&outputPath=components%2Fbtn-with-tip912e2fe6%2Findex"
import script from "./btn-with-tip.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-with-tip912e2fe6%2Findex"
export * from "./btn-with-tip.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-with-tip912e2fe6%2Findex"
import style0 from "./btn-with-tip.mpx?vue&type=style&index=0&id=b54844e0&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_912e2fe6%22%7D&isComponent&outputPath=components%2Fbtn-with-tip912e2fe6%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports